import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "preact/jsx-runtime";
import { useState } from 'preact/hooks';
import { hasTextContent } from '../utils';
export function TCButton({ offer, styles, reserveSpace = false }) {
    const [showModal, setShowModal] = useState(false);
    const buttonStyles = {
        background: 'transparent',
        border: 'none',
        padding: '0',
        fontSize: '12px',
        cursor: 'pointer',
        color: '#777',
        fontFamily: styles.offerText?.font || 'Roboto, sans-serif',
    };
    if (!hasTextContent(offer.terms_and_conditions)) {
        if (!reserveSpace) {
            return null;
        }
        return (_jsx("button", { "aria-hidden": 'true', tabIndex: -1, style: { ...buttonStyles, visibility: 'hidden', cursor: 'default' }, children: "T&C" }));
    }
    const modalOverlayStyles = {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: 20000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    };
    const modalStyles = {
        backgroundColor: styles.popup?.background || '#ffffff',
        borderRadius: '8px',
        maxWidth: '90vw',
        minHeight: '100%',
        width: '500px',
        fontFamily: styles.offerText?.font || 'Roboto, sans-serif',
        overflow: 'hidden',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    };
    const modalHeaderStyles = {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '9px 24px',
        borderBottom: '1px solid #eee',
        background: styles.header?.background || '#f8f9fa',
        color: styles.header?.textColor,
    };
    const modalContentStyles = {
        padding: '20px',
        fontSize: '14px',
        lineHeight: '1.4',
        overflowY: 'auto',
        textAlign: 'start',
    };
    const closeButtonStyles = {
        background: 'transparent',
        border: 'none',
        fontSize: '24px',
        cursor: 'pointer',
        padding: '0',
        width: '30px',
        height: '30px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: styles.header?.textColor,
    };
    return (_jsxs(_Fragment, { children: [_jsx("button", { id: 'adpx_tc-button', style: buttonStyles, onClick: e => {
                    e.stopPropagation();
                    setShowModal(true);
                }, children: "T&C" }), showModal && (_jsx("div", { id: 'adpx_tc-modal-overlay', style: modalOverlayStyles, onClick: () => setShowModal(false), children: _jsxs("div", { id: 'adpx_tc-modal', style: modalStyles, onClick: e => e.stopPropagation(), children: [_jsxs("div", { id: 'adpx_tc-modal-header', style: modalHeaderStyles, children: [_jsx("div", { style: { fontSize: styles.header?.fontSize }, children: "Terms & Conditions" }), _jsx("button", { id: 'adpx_tc-modal-close', style: closeButtonStyles, onClick: () => setShowModal(false), children: "\u00D7" })] }), _jsx("style", { children: `
                #adpx_tc-modal-content ul,
                #adpx_tc-modal-content ol {
                  margin: 8px 0;
                  padding-left: 20px;
                }
              ` }), _jsx("div", { id: 'adpx_tc-modal-content', style: modalContentStyles, dangerouslySetInnerHTML: { __html: offer.terms_and_conditions } })] }) }))] }));
}
